import dayjs from "dayjs";

const shockOption = {
  dataZoom: [
    {
      type: "slider",
      start: 0,
      end: 100,
      show: true,
      showDetail: false,
    },
  ],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
    formatter: function (params) {
      if (!params || params.length === 0) return '';

      const point = params[0];
      const timestamp = point.axisValue;
      const magnitude = point.value;

      // Access the full event payload from the data array [timestamp, magnitude, eventPayload]
      const eventPayload = point.data?.[2];
      const shockData = eventPayload?.deviceAlarm?.shock;

      let tooltip = `${dayjs(timestamp).format("MM-DD-YYYY HH:mm:ss")}<br/>Magnitude: ${magnitude} G`;

      if (shockData) {
        tooltip += `<br/>Threshold: ${shockData.shock_thresh} G`;
        if (shockData.location) {
          tooltip += `<br/>Location: ${shockData.location.latitude.toFixed(6)}, ${shockData.location.longitude.toFixed(6)}`;
        }
        if (shockData.x !== undefined && shockData.y !== undefined && shockData.z !== undefined) {
          tooltip += `<br/>Axis: X=${shockData.x.toFixed(4)}, Y=${shockData.y.toFixed(4)}, Z=${shockData.z.toFixed(4)}`;
        }
      }

      return tooltip;
    },
  },
  grid: {
    left: 60,
    top: 20,
    right: 20,
    bottom: 100,
  },
  xAxis: [
    {
      type: "category",
      name: "Time",
      boundaryGap: true,
      nameGap: 40,
      nameLocation: "middle",
      axisPointer: {
        label: {
          formatter: function (params) {
            return dayjs(params.value).format("MM-DD-YYYY HH:mm:ss");
          },
        },
        handle: {
          show: false,
        },
      },
      axisLabel: {
        hideOverlap: true,
        formatter: function (value) {
          const date = new Date(value);
          const formattedDate = `${(date.getMonth() + 1)
            .toString()
            .padStart(2, "0")}/${date
            .getDate()
            .toString()
            .padStart(2, "0")}/${date.getFullYear()}`;
          return formattedDate;
        },
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      name: "Magnitude (G)",
      nameGap: 40,
      nameRotate: 90,
      nameLocation: "middle",
    },
  ],
  series: [
    {
      name: "Shock Magnitude",
      data: [],
      type: "bar",
      itemStyle: {
        color: '#FF6B6B', // Red color to indicate alarm/warning
      },
    },
  ],
};

export default shockOption;
